export default class CreateDoctorateCtrl {

  constructor ($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig) {
    var createDoctorateVm = this
    const texts = GlobalConfig.appTexts
    const currentUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId
    }
    createDoctorateVm.sourceType = []
    createDoctorateVm.scholarshipProgramType = []
    createDoctorateVm.isEditing = ($stateParams.workplanTeacherActivityId) ? true : false
    createDoctorateVm.rangeType = GlobalConfig.periods.rangeType
    createDoctorateVm.workplanTeacherActivityId = null
    createDoctorateVm.createOrEdit = 'Crear'
    createDoctorateVm.textCreateOrEdit = texts.saved
    createDoctorateVm.createOrEditMV = texts.createDialog
    createDoctorateVm.typePeriod = []
    createDoctorateVm.periodsArray = []
    createDoctorateVm.selectedTypePeriod = {}
    createDoctorateVm.isTouchedPeriods = false
    createDoctorateVm.startDate = null
    createDoctorateVm.endDate = null
    createDoctorateVm.minStartDate = moment().toDate()
    createDoctorateVm.minEndDate = new Date()
    createDoctorateVm.listInstitutions = []
    createDoctorateVm.idCore = null
    createDoctorateVm.isFeedback = currentUser.isFeedback
    createDoctorateVm.dt_start = $cookies.get('wp_start')
    createDoctorateVm.dt_end = $cookies.get('wp_end')

    createDoctorateVm.hasError = hasError
    createDoctorateVm.showErrorMessages = showErrorMessages
    createDoctorateVm.confirmDoctorateAction = confirmDoctorateAction
    createDoctorateVm.validateForm = validateForm
    createDoctorateVm.validateCheklistPeriods = validateCheklistPeriods
    createDoctorateVm.funSelectedPeriod = funSelectedPeriod
    createDoctorateVm.startDateChange = startDateChange
    createDoctorateVm.addDoctorate = addDoctorate
    createDoctorateVm.addOrEditDoctorate = addOrEditDoctorate
    createDoctorateVm.searchInstitution = searchInstitution
    createDoctorateVm.changeInstitution = changeInstitution
    createDoctorateVm.searchCore = searchCore
    createDoctorateVm.changeCore = changeCore
    createDoctorateVm.changeTypeInstitution = changeTypeInstitution
    createDoctorateVm.disableButton = false

    createDoctorateVm.updateRangeType = (val) => {
      createDoctorateVm.rangeType = val
      createDoctorateVm.periodsArray = []
      createDoctorateVm.startDate = null
      createDoctorateVm.endDate = null
    }
    createDoctorateVm.updateRangeData = (val) => {
      createDoctorateVm.periodsArray = val['periods']
      createDoctorateVm.startDate = val['dates'][0]
      createDoctorateVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      if (createDoctorateVm.isEditing) {
        createDoctorateVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        createDoctorateVm.activityTypeId = GlobalConfig.activityTypeId.doctoralEducation
        createDoctorateVm.createOrEdit = 'Editar'
        createDoctorateVm.createOrEditMV = texts.editDialog
        createDoctorateVm.textCreateOrEdit = texts.modified
        getDataDoctorate()
      }

      WorkPlanSrv.getDataPhdList.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn)
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log(data)
        }
      )
      listInstitutions()
    }

    function listInstitutions () {
      WorkPlanSrv.getInstitutionCountry.getList().$promise.then(
          dataReturn => {
            if (dataReturn.status) {
              createDoctorateVm.listInstitutions = dataReturn.institutionCountries
            } else {
              console.log('Comunications problem')
            }
          },
        data => {
          console.log(data)
        }
      )
    }

    function getDataDoctorate () {
      let post = {
        workplanTeacherActivityId: parseInt(createDoctorateVm.workplanTeacherActivityId),
        activityTypeId: parseInt(createDoctorateVm.activityTypeId)
      }
      WorkPlanSrv.getActivityDetailTeachingStaff.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          createDoctorateVm.doctorate = dataReturn.data
          setValues(dataReturn.data)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function loadData (data) {
      createDoctorateVm.scholarshipProgramType = data.listsScholarship.items
      createDoctorateVm.sourceType = data.listsFinancing.items
      createDoctorateVm.cities = data.cities
      createDoctorateVm.listsTypeInstitution = data.listsTypeInstitution.items
      createDoctorateVm.countries = data.countries
      createDoctorateVm.state = data.states
      createDoctorateVm.typePeriod = data.listPeriods
      createDoctorateVm.knowledge = data.listsCoreKnowledge.items
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function addDoctorate () {
      createJson()
    }

    function validateForm (form) {
      return form.$invalid || createDoctorateVm.validateCheklistPeriods()
    }

    function createJson () {
      var doctorate = {
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        namePhd: createDoctorateVm.title,
        hoursPlanning: createDoctorateVm.plannedHours,
        activityId: GlobalConfig.minorActivityId.doctorate,
        cityId: createDoctorateVm.city,
        knowledgeCoreId: createDoctorateVm.idCore,
        knowledgeCoreName: createDoctorateVm.searchTextCore,
        typeInstituteId: createDoctorateVm.institutionType,
        nameInstitute: createDoctorateVm.searchText,
        financingId: createDoctorateVm.financingSource,
        scholarshipId: createDoctorateVm.scholarshipProgram,
        timeRangeTypeId: createDoctorateVm.rangeType,
        isFeedbackActivity: createDoctorateVm.isFeedback
      }

      if (createDoctorateVm.isEditing) {
        doctorate.workplanTeacherActivityId = createDoctorateVm.workplanTeacherActivityId
      }

      if (parseInt(createDoctorateVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createDoctorateVm.periodsArray) {
          var temp = {
            periodId: createDoctorateVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        doctorate.periods = arrayPeriod
      } else {
        doctorate.startDate = new Date(createDoctorateVm.startDate)
        doctorate.endDate = new Date(createDoctorateVm.endDate)
      }

      addOrEditDoctorate(doctorate)
    }

    function addOrEditDoctorate (doctorate) {
      createDoctorateVm.disableButton = true
      WorkPlanSrv.addPhd.save(doctorate).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          confirmDoctorateAction()
        } else {
          createDoctorateVm.disableButton = false
          console.log('Error Comunications')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function confirmDoctorateAction () {
      let header = {
        createOrEdit: createDoctorateVm.createOrEditMV,
        textCreateOrEdit: createDoctorateVm.textCreateOrEdit,
        itemName: createDoctorateVm.title,
        nameModal: texts.modalTypeName.doctoralFormation,
        modalType: texts.modalTypeId.doctoralFormation
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function validateCheklistPeriods () {
      return (createDoctorateVm.rangeType == 1 ? createDoctorateVm.periodsArray.length < 1 : false)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createDoctorateVm.periodsArray.includes(period.periodId)) {
          createDoctorateVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createDoctorateVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createDoctorateVm.periodsArray.splice(index, 1)
        }
      }
      createDoctorateVm.isTouchedPeriods = true
    }

    function startDateChange () {
      let m = moment(createDoctorateVm.startDate)
      createDoctorateVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function setValues (doc) {
      createDoctorateVm.country = doc.countryId
      createDoctorateVm.departament = doc.stateId
      createDoctorateVm.city = doc.cityId
      createDoctorateVm.docKnowledge = doc.knowledgeCoreName
      createDoctorateVm.institutionType = doc.typeInstituteId
      createDoctorateVm.searchText = doc.nameInstitute
      createDoctorateVm.searchTextCore = doc.knowledgeCoreName
      createDoctorateVm.financingSource = doc.financingId
      createDoctorateVm.scholarshipProgram = doc.scholarshipId
      createDoctorateVm.rangeType = doc.timeRangeTypeId
      createDoctorateVm.dt_start = moment(doc.startDate, 'YYYY-MM-DD').toDate()
      createDoctorateVm.dt_end = moment(doc.endDate, 'YYYY-MM-DD').toDate()
      createDoctorateVm.plannedHours = doc.hoursPlanning
      createDoctorateVm.periodsArray = []
      createDoctorateVm.selectedTypePeriod = {}
      createDoctorateVm.title = doc.nameStudy
      if (createDoctorateVm.rangeType == 1) {
        createDoctorateVm.startDate = null
        createDoctorateVm.endDate = null
        var splits = doc.periodId.split(',')
        for (var i = 0; i < splits.length; i++) {
          var valor = splits[i]
          createDoctorateVm.periodsArray.push(parseInt(valor))
          createDoctorateVm.selectedTypePeriod[valor] = true
        }
      }

      if (doc.startDate) {
        var startDateNew = moment(doc.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createDoctorateVm.minStartDate = moment(doc.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      $timeout(function () {
        createDoctorateVm.country = doc.countryId
        createDoctorateVm.departament = doc.stateId
        createDoctorateVm.city = doc.cityId
      }, 500)

      createDoctorateVm.isEditing = true
    }

    function searchCore (searchText) {
      if (!createDoctorateVm.knowledge) {
        return
      }

      let matcher = new RegExp(searchText, 'i')
      let arr = []
      let attr = 'listItemName'
      createDoctorateVm.knowledge.forEach((searchText) => {
        if (searchText[attr].match(matcher)) {
          arr.push(searchText)
        }
      })
      return arr
    }

    function searchInstitution (searchText, type) {
      let matcher = new RegExp(searchText, 'i')
      let arr = []
      let attr = 'nameInstitution'
      createDoctorateVm.listInstitutions.forEach((list) => {
        if (list.idInstitution == type) {
          if (list[attr].match(matcher)) {
            arr.push(list)
          }
        }
      })
      return arr
    }

    function changeInstitution (doc) {
      if (doc) {
        createDoctorateVm.country = doc.countryId
        createDoctorateVm.departament = doc.stateId
        createDoctorateVm.city = doc.cityId
      } else {
        createDoctorateVm.country = null
        createDoctorateVm.departament = null
        createDoctorateVm.city = null
      }
    }

    function changeCore (core) {
      if (!core) {
        return
      }

      createDoctorateVm.idCore = core.idListItem
    }

    function changeTypeInstitution () {
      createDoctorateVm.country = null
      createDoctorateVm.departament = null
      createDoctorateVm.city = null
      createDoctorateVm.searchText = ''
      createDoctorateVm.selectedItem = null
    }
  }// FIN DEL CONSTRUCTOR

  rbPlanifications (bool) {
    if (bool) {
      this.startDate = null
      this.endDate = null
    } else {
      this.periodsArray = []
      this.selectedTypePeriod = null
      this.startDate = null
      this.endDate = null
    }
  }

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}

CreateDoctorateCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/consolidationCP/doctoralFormation/create/createDoctorateCtrl.js